import React from 'react';

export default function ResultPage({ costPriceLostPerYear, salesValueLostPerYear, gotoSignupNowPage, numberOfChars, currency }) {

  return (
    <div className="draught-wastage__page draught-wastage__result">
      <div className="draught-wastage__poor-dispense draught-wastage__small-text">
        <p>Poor dispense is costing you...</p>
        <p className={numberOfChars}>
          {currency(costPriceLostPerYear, '£', 0, { thousandsSeparator: '' })}
        </p>
      </div>
      <div className="draught-wastage__text-holder narrow">
        <p className="draught-wastage__headline">
          All of this waste is costing you{' '}
          <span>{currency(salesValueLostPerYear, '£', 0)}</span>{' '}in sales
        </p>
        <p className="draught-wastage__small-text">
          Check out our online course on how to improve dispense and save you money
        </p>
        <button onClick={gotoSignupNowPage}>View course now &gt;</button>
      </div>
    </div>
  );
}
